import { useEffect, useMemo, useState } from 'react';
import prometheusClient from './prometheusClient';
import { useTimer } from './useTimer';
const tenMinutes = 10 * 60 * 1000;
export const useMeasureLoadingTime = (eventName, sessionStatus, options) => {
  const prometheus = useMemo(() => {
    var _ref;
    return prometheusClient((_ref = options.environment) !== null && _ref !== void 0 ? _ref : 'LOCAL');
  }, [options.environment]);
  const {
    start,
    stop
  } = useTimer();
  const [isCancelled, setIsCancelled] = useState(false);
  const cancel = () => {
    setIsCancelled(true);
  };
  useEffect(() => {
    if (isCancelled) {
      return;
    }
    switch (sessionStatus.status) {
      case 'pending':
        start();
        return;
      case 'running':
        {
          const time = stop();
          const invalidMetric = !time || time > tenMinutes || !options.courseId;
          if (invalidMetric) {
            return;
          }
          prometheus.observeDistribution(eventName, {
            appName: 'campus-app',
            courseId: options.courseId,
            environment: options.environment,
            isNewSession: sessionStatus.isNewSession,
            technology: options.technology
          }, time);
          break;
        }
      default:
    }
  }, [eventName, isCancelled, options.courseId, options.environment, options.technology, prometheus, start, stop, sessionStatus.isNewSession, sessionStatus.status]);
  return {
    cancel
  };
};